<template>
  <eb-panel>
    <eb-panel-header class="panel-header" slot="header">
      <span slot="title">模板信息</span>
    </eb-panel-header>
    <div slot="body">
      <div class="panel-body-row">
        <div class="panel-body-row-left">模板编号</div>
        <div class="panel-body-row-right">{{ruleTemplate.templateCode}}</div>
      </div>
      <div class="panel-body-row">
        <div class="panel-body-row-left">模板名称</div>
        <div class="panel-body-row-right">{{ruleTemplate.templateName}}</div>
      </div>
      <div class="panel-body-row">
        <div class="panel-body-row-left">模板备注</div>
        <div class="panel-body-row-right">{{ruleTemplate.templateMemo}}</div>
      </div>
    </div>
  </eb-panel>
</template>
<script>
import EbPanel from '@/components/common/panel/eb-panel';
import EbPanelHeader from '@/components/common/panel/eb-panel-header';

export default {
  name: '',
  components: {
    EbPanel,
    EbPanelHeader
  },
  filters: {},
  props: {
    ruleTemplate: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>
<style lang="less">
</style>
